import { z } from "zod";

import { apiSlice } from "api/api.slice";
import type { SimilarDimensionArg } from "api/api.types";
import { knowledgeSchema } from "api/schemas/knowledgeApiSchema";
import { toSearchString } from "api/utils";

export const knowledgeApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getSimilarKnowledgeByDimension: build.query({
      query: ({ body, search }: SimilarDimensionArg) => ({
        body,
        method: "POST",
        url: `/knowledge/similar/dimension${toSearchString(search)}`,
      }),
      responseSchema: z.array(knowledgeSchema),
    }),
  }),
});

export const { useGetSimilarKnowledgeByDimensionQuery, useLazyGetSimilarKnowledgeByDimensionQuery } = knowledgeApiSlice;
